module.exports = __webpack_public_path__ + "img/icon_easy-to-plan.410c9d24.svg";